type SessionExpiredToastHandler = (message: string) => void;

let sessionExpiredToastHandler: SessionExpiredToastHandler | null = null;

export function registerSessionExpiredToast(
  handler: SessionExpiredToastHandler,
): () => void {
  sessionExpiredToastHandler = handler;

  return () => {
    if (sessionExpiredToastHandler === handler) {
      sessionExpiredToastHandler = null;
    }
  };
}

export function showSessionExpiredToast(message: string): void {
  sessionExpiredToastHandler?.(message);
}
